
 <div class="nav-menu-overlay" [ngClass]="[!exitModalShow && questionsService.showMenu ? 'active' : '']">
</div>
    <div class="nav-menu-container" [ngClass]="[!exitModalShow && questionsService.showMenu ? 'active' : '']">

        <div class="nav-menu" [ngClass]="[questionsService.showMenu ? 'active' : '']">

            <div class="nav-menu-content" [ngClass]="[questionsService.showMenu ? 'active' : '']">
                <ul>
                    <li><a class="blue" href="">SkillStat</a></li>
                    <li><a class="dashboard" href="https://www.skillstat.com/dashboard/" target="_parent">Dashboard</a></li>
                    <li [ngClass]="[modeType == 'rhythms' ? 'active' : '']"><div class="decks">Decks</div>
                        <ul>
                            <li><a href="" (click)="this.exitGameWarning($event, '/rhythms?view=rhythms')">Rhythms</a></li>
                            <li><a href="" (click)="this.exitGameWarning($event, '/rhythms?view=extras')">Extras</a></li>
                            <li><a href="" (click)="this.exitGameWarning($event, '/rhythms?view=12 lead')">12 Lead</a></li>
                        </ul>
                    </li>

                    <li [ngClass]="[modeType == 'play' ? 'active' : '']" style="margin-bottom: 30px;"><div class="play">Play</div>
                        <ul>
                            <li><a href="#" (click)="this.exitGameWarning($event, '/play?modeTitle=Rhythms Only')">Rhythms Only</a></li>
                            <li><a href="#" (click)="this.exitGameWarning($event, '/play?modeTitle=Practitioner')">Practitioner</a></li>
                        </ul>
                    </li>
                    <li class="sound-item">
                        <div class="settings">Sound</div>
                        <div class="mute-container">
                            <span (click)="playIntroService.gameSoundMute = !playIntroService.gameSoundMute"
                            [ngClass]="!playIntroService.gameSoundMute ? 'muted' : 'unmuted'">
                                <ng-container *ngIf="!playIntroService.gameSoundMute">
                                    <!-- <img src="assets/unmute-btn.svg" /> -->

                                    <div class="sound-button on">
                                        <div class="sound-toggle right"></div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="playIntroService.gameSoundMute">

                                    <div class="sound-button off">
                                        <div class="sound-toggle left"></div>
                                    </div>
                                    <!-- <img src="assets/mute-btn.svg" /> -->
                                </ng-container>
                            </span>

                        </div>
                    </li>
                    <ng-container *ngIf="modeType == 'play'">
                        <li class="exit-game"><div class="exit" (click)="this.exitGameWarning($event, '/')">Exit Game</div></li>
                    </ng-container>
                </ul>
            </div>

        </div>

    </div>


<div class="exit-game-overlay" [ngClass]="[exitModalShow ? 'active' : '']">

    <div class="exit-game-modal">

        <h2>Are you sure you want to exit the game?</h2>
        <p>your progress will be lost.</p>
        <br />
        <div class="buttons">
            <a href="" class="cancel" (click)="this.cancelAction($event)">cancel</a>
            <a href="" (click)="this.confirmAction($event)">ok</a>
        </div>

    </div>

</div>
